import { render, staticRenderFns } from "./MessageTypeAssignation.vue?vue&type=template&id=4459d353"
import script from "./MessageTypeAssignation.vue?vue&type=script&lang=js"
export * from "./MessageTypeAssignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports